import Flickity from 'flickity';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

export default {
  init($element) {

  },
  finalize($element) {

    if ($element.find('.mobile-carousel')) {
      const mobileCarousel = new Flickity($element.find('.mobile-carousel').get()[0], {
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        cellAlign: 'left',
        on: {
          ready: function() {
            window.dispatchEvent(new Event('resize')); // Quickfix for sizing issue
          },
        },
      });
    }

    const latestEvents = $element.get();

    $element.find('.events-row .col-lg-6').each(function(i) {
      const thisItem = $(this).get();

      gsap.fromTo(thisItem, {
        top: '20px',
        opacity: 0,
      }, {
        top: 0,
        opacity: 1,
        duration: 0.6,
        delay: (i * 0.3),
        scrollTrigger: {
          trigger: latestEvents,
          start: 'top 70%',
        },
      });
    });

  },
}


// WEBPACK FOOTER //
// ./scripts/partials/home/latestEvents.js